import React, { useState, useRef } from 'react';
import { Upload, FileArchive } from 'lucide-react';
import { Button } from '../../ui/Button';
import { useRestoreDump } from '../../../api/backup';
import { toast } from 'sonner';

interface ImportDumpStepProps {
  onRestored: () => void;
}

export function ImportDumpStep({ onRestored }: ImportDumpStepProps) {
  const [file, setFile] = useState<File | null>(null);
  const fileRef = useRef<HTMLInputElement>(null);
  const restoreMutation = useRestoreDump();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0];
    if (f) setFile(f);
  };

  const handleRestore = () => {
    if (!file) return;
    restoreMutation.mutate(file, {
      onSuccess: () => {
        toast.success('Backup ripristinato con successo');
        onRestored();
      },
      onError: (err) => toast.error((err as Error).message),
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
        Carica un file di backup (.dump o .json) generato da un'altra installazione di LensCRM.
        Tutti i dati esistenti verranno sostituiti.
      </p>

      <div
        onClick={() => fileRef.current?.click()}
        style={{
          border: '2px dashed rgba(255,255,255,0.10)',
          borderRadius: 'var(--radius-card)',
          padding: '2rem',
          textAlign: 'center',
          cursor: 'pointer',
          background: 'var(--glass-bg-card)',
        }}
      >
        <input
          ref={fileRef}
          type="file"
          accept=".dump,.json"
          onChange={handleFileChange}
          style={{ display: 'none' }}
        />
        {file ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', justifyContent: 'center' }}>
            <FileArchive size={20} />
            <span style={{ fontSize: 'var(--text-sm)' }}>{file.name} ({(file.size / 1024).toFixed(1)} KB)</span>
          </div>
        ) : (
          <div style={{ color: 'var(--color-text-muted)' }}>
            <Upload size={24} style={{ margin: '0 auto 0.5rem' }} />
            <p style={{ fontSize: 'var(--text-sm)' }}>Clicca per selezionare un file .dump o .json</p>
          </div>
        )}
      </div>

      <Button
        onClick={handleRestore}
        disabled={!file}
        loading={restoreMutation.isPending}
      >
        Ripristina backup
      </Button>
    </div>
  );
}
